<template>
  <div class="animated fadeIn">
    <project-soil-field-form-groups :submissionId="submissionId" />
    <project-field-form-group
      :submissionId="submissionId"
      :formLabel="'Field ID'"
    />
    <hr class="mt-0" />
    <project-soil-next-crop-form-groups :submissionId="submissionId" />
    <hr />
    <turn-around-select
      :submissionId="submissionId"
      :turnArounds="turnArounds"
    />
    <hr />
    <template v-if="zones && zones.length">
      <project-soil-zone-form-group
        v-for="(zone, index) in zones"
        :key="index"
        :submissionId="submissionId"
        :zone_id="zone.zone_id"
        :addOns="addOns"
        :testPackage="testPackage"
        :allTestPackages="allTestPackages"
        @updateSampleList="updateSampleList"
      />
    </template>
    <div>
      <b-row class="mb-3" align-h="end">
        <b-col class="pr-0" cols="2">
          <b-button
            variant="success"
            block
            @click="updateSampleList({ action: 'add' })"
          >
            <i class="fa fa-plus" /> Add
          </b-button>
        </b-col>
        <b-col cols="3">
          <b-input-group append="Zone(s)" :horizontal="true">
            <b-form-input
              type="number"
              min="1"
              v-model="new_zone_quantity"
              @change="handleQuantityChange"
            />
          </b-input-group>
        </b-col>
      </b-row>
    </div>
    <div v-if="serviceQuestions && serviceQuestions.length">
      <hr />
      <service-question
        v-for="i in serviceQuestions"
        :serviceQuestion="i"
        :key="i.id"
      />
    </div>
  </div>
</template>

<script>
import ProjectFieldFormGroup from "../../misc/ProjectFieldFormGroup";
import ProjectSoilFieldFormGroups from "./ProjectSoilFieldFormGroups";
import ProjectSoilNextCropFormGroups from "./ProjectSoilNextCropFormGroups";
import ProjectSoilZoneFormGroup from "./ProjectSoilZoneFormGroup";
import ServiceQuestion from "../../misc/ServiceQuestion";
import TurnAroundSelect from "../../misc/TurnAroundSelect";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ProjectSoilSubmissionForm",
  components: {
    ProjectFieldFormGroup,
    ProjectSoilFieldFormGroups,
    ProjectSoilNextCropFormGroups,
    ProjectSoilZoneFormGroup,
    ServiceQuestion,
    TurnAroundSelect,
  },
  props: {
    submissionId: {
      type: String,
      default: "",
    },
    addOns: {
      type: Array,
      default: () => [],
    },
    turnArounds: {
      type: Array,
      default: () => [],
    },
    serviceQuestions: {
      type: Array,
      default: () => [],
    },
    testPackage: {
      type: Object,
      default: () => (null),
    },
    allTestPackages: {
      type: Array,
      default: () => [],
    }
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission",
    }),
    current_submission() {
      return this.submission(this.submissionId);
    },
    zones() {
      return this.current_submission.zones;
    },
  },
  data() {
    return {
      new_zone_quantity: null,
    };
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION"]),
    handleQuantityChange(value) {
      this.new_zone_quantity = value;
    },
    updateSampleList({ action, zone_id }) {
      let zone_list_update = JSON.parse(JSON.stringify(this.zones));
      switch (action) {
        case "add":
          if (this.new_zone_quantity) {
            const last_zone = JSON.parse(
              JSON.stringify(this.zones[this.zones.length - 1])
            );
            let counter = 0;
            while (counter < this.new_zone_quantity) {
              counter++;
              zone_list_update = [
                ...zone_list_update,
                {
                  identifier: null,
                  zone_id: this.$uuid.v4(),
                  samples: last_zone.samples.map((sample) => ({
                    ...sample,
                    add_ons: [...sample.add_ons],
                    identifier: null,
                    test_package_sample_id: this.$uuid.v4(),
                  })),
                },
              ];
            }
          }
          break;
        case "remove":
          zone_list_update = this.zones.filter(
            (zone) => zone.zone_id !== zone_id
          );
          break;
        default:
      }
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value: zone_list_update,
        name: "zones",
      });
      this.new_zone_quantity = null;
    },
  },
};
</script>
